import { createAction } from "@reduxjs/toolkit";

export const logOut = createAction("auth/logOut");
export const setCredentials = createAction("auth/setCredentials");
export const setTrustDevice = createAction("auth/setTrustDevice");
